// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export default function Footer() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Stack
            direction={isMobile ? 'column' : 'row'}
            sx={{
                alignItems: isMobile ? 'flex-start' : 'center',
                justifyContent: 'space-between',
                p: '24px 16px 0px',
                mt: 'auto',
                gap: isMobile ? 2 : 0
            }}
        >
            <Typography variant="caption" sx={{ ml: isMobile ? 0 : '24px' }}>
                © Tervify | Fejlesztve és Üzemeltetve:{' '}
                <Link href="https://kocsismihaly.hu/" target="_blank" underline="hover">
                    Kocsis IT Solutions
                </Link>
            </Typography>
            <Stack
                direction={isMobile ? 'column' : 'row'}
                sx={{
                    gap: 1.5,
                    alignItems: isMobile ? 'flex-start' : 'center',
                    justifyContent: 'space-between',
                    mr: isMobile ? 0 : '24px'
                }}
            >
                <Link href="#" target="_blank" variant="caption" color="text.primary">
                    Felhasználási Feltételek
                </Link>
                <Link href="#" target="_blank" variant="caption" color="text.primary">
                    Adatvédelmi Szabályzat
                </Link>
                <Link href="#" target="_blank" variant="caption" color="text.primary">
                    Impresszum
                </Link>
            </Stack>
        </Stack>
    );
}